module.exports = __webpack_public_path__ + "static/media/twelve.a8489204.jpg";